import { useDispatch, useSelector } from "react-redux";
import useLanguageChange from "../../hooks/useLanguageChange";
import CenterModal from "../UI/Modal/CenterModal";
import { setConfirmExitMarkup } from "../../reducers/markup-reducer";
import { PublicVariables } from "../../constants/PublicVariables";
import { ENABLED } from "../../constants/Constants";
import markupService from "../../services/MarkupService/markupService";

const ConfirmExitMarkupModal = () => {
    const dispatch = useDispatch();
    const localisedValues = useLanguageChange();
    const { confirmExitMarkup, continueMarkup } = useSelector((state) => state.markup);

    const handleCloseModal = () => {
        dispatch(setConfirmExitMarkup(false));
    };

    const markupHandler = (from) => {
        if (from === "exit") {
            markupService.toggleannotationdiv(false, false, true);
        } else if (from === "saveAndExit") {
            markupService.toggleannotationdiv(false, true, true);
        } else {
            handleCloseModal();
        }
    };

    const modalHeader = <h5 className='modal-title'>{localisedValues["message_title"]}</h5>;

    const modalBody = (
        <div className='cms-modal-text' data-testid='exit-markup-pop'>
            <p>
                {PublicVariables.featureFlag?.SHOWMESAVEMARKUP == ENABLED
                    ? localisedValues["would_you_like_to_save_image"]
                    : localisedValues["would_you_like_to_exit_markup"]}
            </p>
        </div>
    );

    const modalFooter = (
        <div className='button-inline button-inline-tb-space d-flex align-items-center justify-content-end'>
            <div className='button'>
                <button className='btn default-btn-primary' onClick={markupHandler} disabled={!continueMarkup}>
                    {localisedValues["continue_markup"]}
                </button>
            </div>
            {PublicVariables.featureFlag?.SHOWMESAVEMARKUP == ENABLED && (
                <div className='button'>
                    <button
                        className='btn default-btn-primary'
                        onClick={() => {
                            markupHandler("saveAndExit");
                        }}
                    >
                        {localisedValues["save_and_exit"]}
                    </button>
                </div>
            )}
            <div className='button'>
                <button
                    className='btn default-btn-primary'
                    onClick={() => {
                        markupHandler("exit");
                    }}
                    data-testid='exit-button'
                >
                    {localisedValues["exit_markup"]}
                </button>
            </div>
        </div>
    );

    return (
        <CenterModal
            showModal={confirmExitMarkup}
            closeModal={handleCloseModal}
            modalClass='default-modal modal-medium mob-bottom-top'
            bodyClassName='default-custom-scroll'
            className='modal-dialog-centered'
            header={modalHeader}
            body={modalBody}
            footer={modalFooter}
            backdrop={"static"}
        />
    );
};

export default ConfirmExitMarkupModal;
